var map = {
  "./AriaSymptoms/Document/": "64231",
  "./Background/Document/": "25284",
  "./Behaviour/Document/": "41035",
  "./Checklist/Document/": "45345",
  "./Clinicalstudy/Document/": "8174",
  "./ClpAndCnpTests/Document/": "16964",
  "./Cognition/Document/": "21823",
  "./Comorbidity/Document/": "3237",
  "./Dbs/Document/": "21540",
  "./Diagnosis/Document/": "10356",
  "./DiagnosticSurvey/Document/": "27887",
  "./DiagnosticTests/Document/": "84488",
  "./DietTherapy/Document/": "46198",
  "./DoctorsOrders/Document/": "24619",
  "./Examination/Document/": "22371",
  "./FunctionalPerformance/Document/": "4829",
  "./FunctionalPerformanceMgravis/Document/": "65787",
  "./GeneTest/Document/": "25193",
  "./Generalhealth/Document/": "16817",
  "./Imaging/Document/": "38381",
  "./InflammatoryDiseaseActivity/Document/": "99570",
  "./InterviewSurveys/Document/": "75666",
  "./Lifestyle/Document/": "90948",
  "./Medication/Document/": "59379",
  "./Motor/Document/": "43284",
  "./MotorFunctionAndMobilityAid/Document/": "95390",
  "./MotorFunctionHuntington/Document/": "43977",
  "./MyService/Document/": "65005",
  "./NeurologicalStatusAndEDSS/Document/": "22850",
  "./Notes/Document/": "25303",
  "./Nutrition/Document/": "40070",
  "./OtherSymptoms/Document/": "89357",
  "./PatientFiles/Document/": "35341",
  "./PolyneuroDiagnosticExams/Document/": "36150",
  "./Procedure/Document/": "86965",
  "./Profile/Document/": "12068",
  "./Pulmonary/Document/": "28451",
  "./Relapse/Document/": "85963",
  "./Rtms/Document/": "16815",
  "./Seizure/Document/": "1105",
  "./SurgicalTreatment/Document/": "61634",
  "./Tdcs/Document/": "170",
  "./ThalamotomyHifu/Document/": "93201",
  "./Therapy/Document/": "9002",
  "./Treatment/Document/": "90384",
  "./Updrs/Document/": "52524",
  "./Vns/Document/": "32176",
  "./_Boilerplate/Document/": "83318"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 31889;
